import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './home/home.component';
import { HeroBannerComponent } from './shared/components/hero-banner/hero-banner.component';
import { PeopleTilesComponent } from './shared/components/people-tiles/people-tiles.component';
import { NewsComponent } from './news/news.component';
import { NewsPR1Component } from './news/pr1.component';
import { NewsPR2Component } from './news/pr2.component';
import { Pr3Component } from './news/pr3.component';
import { Pr4Component } from './news/pr4.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    HeroBannerComponent,
    PeopleTilesComponent,
    NewsComponent,
    NewsPR1Component,
    NewsPR2Component,
    Pr3Component,
    Pr4Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
